import React from "react";
import { connect } from "react-redux";

import HeaderBar from "./headerbar";
import { initApp } from "../../actions/appInitAct";
import { getLoggedProfile } from "../../actions/sessionAct";
import { commonErr } from "../common/errors";

class Header extends React.Component {
	constructor() {
		super();
	}

	componentDidMount() {
		if (this.props.appInit.err === commonErr.INNIT) {
			this.props.dispatch(initApp());
		}
		if (this.props.session.profile.err === commonErr.INNIT) {
			this.props.dispatch(getLoggedProfile());
		}
	}

	render() {
		return (
			<HeaderBar
				notLineHeader={this.props.notLineHeader}
				fixed={this.props.fixed}
				visible={this.props.visible}
				carFinding={this.props.carFinding}>
				{this.props.children}
			</HeaderBar>
		);
	}
}

function mapInitState(state) {
	return {
		appInit: state.appInit,
	};
}

function mapSessionState(state) {
	return {
		session: state.session,
	};
}

Header = connect(mapInitState)(Header);
Header = connect(mapSessionState)(Header);

export default Header;
